module.exports = __webpack_public_path__ + "img/en.bc44e9ca.png";